module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', _vm._l((_vm.contourExtents), function(contourExtent, index) {
    return _c('g', {
      key: index
    }, [_c('visualization-contour', {
      key: _vm.spot.id,
      attrs: {
        "layer-type": _vm.layerType,
        "x": contourExtent.extent.x,
        "y": contourExtent.extent.y,
        "width": contourExtent.extent.width,
        "height": contourExtent.extent.height,
        "thingsSpotList": _vm.thingsSpotList
      }
    })], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f60d389","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/visualization/partials/contours_spot.vue
// module id = 884
// module chunks = 0